// extracted by mini-css-extract-plugin
export var content = "LandingGenericSectionWithList-module--content--12598";
export var wrapper = "LandingGenericSectionWithList-module--wrapper--ab527";